
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { listadoUsuariosRol, usuarioPorID } from "../../../services";






export const useUsuarioXID = (id) => {

    const userXIDQuery = useQuery({
        queryKey: ['usuario-id', id], 
        queryFn: () => usuarioPorID(id),
    });

    return {
        userXIDQuery
    }
}





export const useUsuariosTodosRol = (rol) => {
    
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');


    const todoUsuariosQuery = useQuery({
        queryKey: ['usuarios-rol', { page, termino, rol }], 
        queryFn: () => listadoUsuariosRol({ page, termino, rol }),
    });


    const chagePage = (num) => {
        setPage(num - 1);
    }


    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }


    
    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        todoUsuariosQuery,
    }
}
